import React, { useEffect } from 'react';
import Topnavigation from '../../../../layouts/Topnavigation';
import Sidenavigation1 from '../../../../layouts/Sidenavigation1';

import Content from './Content';
import parse from 'html-react-parser';
import { TheMasterContextProvider } from '../../../../MyContexts/Master_Context';
import OrderFunctions from '../../../../../MyFunctions/OrderFunctions';
import Translator from '../../../../../MyFunctions/Translator';
import myFunctions from '../../../../../myFunctions';

const InvoiceTable = (props) => {

    useEffect(() => {
    }, [])

    //מציג את כל הנלווים של המוצר
    const getSpecials = (ordItem, ordItmIndx) => {
        let specCount = 0;
        let price = 0;
        let vals;
        let specc =
            ordItem.prodOptions?.map((optionGroup, index) => {
                specCount++;
                const selectedOptions = optionGroup.options.filter((opt) => opt.selected); // Get selected options                                                          
                return selectedOptions.length > 0 ? (
                    <div key={index}>
                        <span className={"fullRow smallFont"}>{optionGroup.optionName}:</span>
                        <div>
                            {selectedOptions.map((selectedOpt, optIndex) => {
                                price += selectedOpt.addToPrice * selectedOpt.mount;
                                return (
                                    <div key={optIndex}>
                                        <div className={"fullRow mediumFont bold"}>
                                            {selectedOpt.servType}
                                            <div className={"onRight"}> {selectedOpt.mount > 1 ? ` כמות: ${(selectedOpt.mount)}` : ""}</div>
                                            {!props.isForKitchen && <div className={"onLeft small bold"}>{selectedOpt.addToPrice > 0 ? `+₪${(selectedOpt.addToPrice * selectedOpt.mount)}` : ""}</div>}
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                ) : null;
            })
        if (specCount > 0) {
            vals =
                <div key={ordItmIndx} className={""}>
                    {specc}
                </div>
        }
        return (
            { vals, price }
        )
    }


    return (
        <div className="ms-panel-body ordertblBody">

            {/* Invoice Table */}
            <div className="ms-invoice-table table-responsive">
                <table className="table table-hover text-right thead-light">
                    <thead>

                        <tr className="text-capitalize">
                            <th className="text-center w-5">{props.arabic ? Translator.getInArab("כמות") : "כמות"}</th>
                            {!props.isForKitchen && <th className="centerText">{props.arabic ? Translator.getInArab("ליח'") : "ליח'"}</th>}
                            <th className="textRight">{props.arabic ? Translator.getInArab("שם המוצר") : "שם המוצר"}</th>
                            {/* {!props.isForKitchen && <th className="textRight">{props.arabic ? Translator.getInArab("תיאור") : "תיאור"}</th>} */}
                            {!props.isForKitchen && <th>{props.arabic ? Translator.getInArab(`סה"כ`) : `סה"כ`}</th>}
                        </tr>
                    </thead>
                    <tbody>
                        {props.theOrder?.orderItems.map((item, i) => {
                            let Specialss = getSpecials(item, i);

                            // Render a row for each mount
                            return Array.from({ length: item.mount }).map((_, jump) => (
                                <tr key={`${i}-${jump}`}>
                                    <td className={`centerText bold ${props.isForKitchen && "width_10perc"}`}>{1}</td>
                                    {!props.isForKitchen && <td><div className="centerText mediumFont small bold">₪{parseFloat(item.basePrice)}</div></td>}

                                    <td className="textRight width_40perc">
                                        <span className="textRight bold">{item.prodName}</span>

                                        {(item.Remarks) ?
                                            <>
                                                <div>{Specialss.vals}</div>
                                                <br />
                                                <div className="textRight bold" >
                                                    {props.arabic ? Translator.getInArab("הערה") : "הערה"}: {item.Remarks}</div>
                                            </>
                                            : Specialss.vals
                                        }
                                    </td>

                                    {!props.isForKitchen && <td className="textRight bold">₪{(parseFloat(item.basePrice) + parseFloat(Specialss.price))}</td>}
                                </tr>
                            ));

                        })}
                        {(!props.isForKitchen && props.theOrder?.OrderType !== "Take") ?
                            <tr className={"specialRow"} key={props.theOrder?.orderItems.length + 1}>
                                <td className="centerText bold">1</td>
                                <td className="centerText bold"></td>
                                <td colSpan={1} className="textRight bold">{props.arabic ? Translator.getInArab("משלוח") : `משלוח (${props.theOrder.deliveryAddress?.city})`}</td>
                                <td className="textRight bold">₪{props.theOrder?.deliveryPrice}</td>
                            </tr>
                            : ""}
                    </tbody>
                    <tfoot>
                        {!props.isForKitchen &&
                            <tr>
                                <td colSpan={3} className="bold veryBig textLeft ">{props.arabic ? Translator.getInArab(`סה"כ`) : `סה"כ`}: </td>
                                <td className="bold veryBig">{(props.theOrder != null) ? `₪${props.theOrder.totalPrice}` : ""} </td>
                            </tr>
                        }
                        {!props.isForPrint && !props.isForKitchen &&
                            <tr>
                                <td colSpan={3} className="bold veryBig textLeft ">{props.arabic ? Translator.getInArab("אופן תשלום") : "אופן תשלום"}:</td>
                                <td className="bold veryBig">
                                    {props.arabic ? Translator.getInArab(OrderFunctions.payingTYpe(props.theOrder)) : OrderFunctions.payingTYpe(props.theOrder)}
                                </td>
                            </tr>
                        }

                    </tfoot>
                </table>
            </div>
        </div>
    )
}

export default InvoiceTable;